module.exports = __webpack_public_path__ + "static/media/F-1-mobile.28542b2d.webp";